import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import HeaderLogo from './HeaderLogo';
import Nav from './Nav';
import socialSpriteImgUrl from '../../images/footer/social-sprite.svg';

const Header = () => (
	<AppBar
		position='static'
		color='transparent'
		className='border-0 border-b border-solid border-gray-200'
	>
		<Toolbar className='flex py-2 md:py-0 px-1 sm:px-3 space-y-2 sm:space-y-3  md:space-y-0 flex-col items-center  md:flex-row md:justify-between '>
			<HeaderLogo />
			<Nav />
			<Button
				className='hidden lg:inline-flex lg:space-x-2 lg:items-center lg:text-lg xl:text-xl xl:px-4 '
				variant='contained'
				href='https://www.linkedin.com/in/amrsaadabdallah'
				target='_blank'
			>
				<svg
					aria-label='linkedin icon'
					className='w-6 h-6 p-1 rounded-sm bg-white block fill-current text-primary-dark'
				>
					<use href={`${socialSpriteImgUrl}#linkedin`} />
				</svg>
				<span>let's Connect</span>
			</Button>
		</Toolbar>
	</AppBar>
);
export default Header;
